import type { AnyUseInfiniteQueryOptions, AnyUseQueryOptions, QueryClient } from "@tanstack/react-query";

export type WarmableQuery = AnyUseQueryOptions | AnyUseInfiniteQueryOptions;

const isInfinite = (query: WarmableQuery): query is AnyUseInfiniteQueryOptions => "getNextPageParam" in query;

export const loadQueries = (queryClient: QueryClient, queries: ReadonlyArray<WarmableQuery>) =>
  Promise.all(
    queries
      .filter((query) => query.enabled !== false)
      .map((query) =>
        isInfinite(query)
          ? queryClient.infiniteQuery({ ...query, staleTime: "static" })
          : queryClient.query({ ...query, staleTime: "static" }),
      ),
  );

export const warmQueries = (queryClient: QueryClient, queries: ReadonlyArray<WarmableQuery>) => {
  void loadQueries(queryClient, queries).catch(() => {});
};
